export function getAttr(el, attr) {
  return el.getAttribute(attr);
}


//////////////////
// WEBPACK FOOTER
// /Users/nickgehring/code/ymprealestate/wp-content/themes/ymprealestate/node_modules/tiny-slider/src/helpers/getAttr.js
// module id = 38
// module chunks = 0